<template>
  <v-app id="app">
    <top-navigation-bar></top-navigation-bar>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>
<script>
  import { ForgeMessage, isParentOrigin } from '@Utils/forgeMessageUtils';
  import { updateMarkupsStyle } from '@Scripts/js/forgeService';
  import { drawImage64OnPlane, drawImageOnPlane } from '@Scripts/js/forgeviewer';
  import store from '@Store';
  import TopNavigationBar from '@Share/components/TopNavigationBar.vue';
  import { $has } from '@/utils';
  import permissions from '@Share/config/permissions';

  export default {
    name: 'default-layout',
    created() {
      if (isParentOrigin()) {
        let forgeMessage = new ForgeMessage('get-next-test-blind-sequence', null);
        forgeMessage.send();
      }

      window.updateMarkupsStyle = updateMarkupsStyle;
      window.drawImage64OnPlane = drawImage64OnPlane;
      window.drawImageOnPlane = drawImageOnPlane;
      store.dispatch('GET_DATA_FROM_LOCAL_STORAGE');
      store.dispatch('TASK_MANAGER/GET_BY_USER');
      store.dispatch('REGISTERS/FETCH_USER_FACILITY_REGISTERS');
      if ($has(permissions.Users.View)){
        store.dispatch('USER/GET');

      }
      
    },
    components: {
      TopNavigationBar,
    },
  };
</script>

<style>
  @import '../styles/main.css';

  #app {
    width: 100vw;
    height: 100vh;
  }
</style>
